var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contain"},[_c('TencentMapLocation',{key:_vm.timerKey}),(_vm.checkinSelected)?_c('SignCheckin'):_vm._e(),(!_vm.checkinSelected)?_c('SignCheckStatic'):_vm._e(),_c('CheckInBottomFunc')],1)}
var staticRenderFns = []

export { render, staticRenderFns }